import { useState } from "react";
import DrawerClosetRTCChangeStep from './DrawerClosetRTCChangeStep';
import DrawerClosetRTCValidationStep from './DrawerClosetRTCValidationStep';
import DrawerClosetRTCBonusItemExplanation from './DrawerClosetRTCBonusItemExplanation';

function DrawerClosetRTC () {
  const [step, setStep] = useState("closetChange");

  return (
    <>
      <DrawerClosetRTCChangeStep
        setStep={setStep}
      />
      <DrawerClosetRTCBonusItemExplanation
        open={step === "bonusItemExplanation"}
        setStep={setStep}
      />
      <DrawerClosetRTCValidationStep
        open={step === "closetValidation"}
        setStep={setStep}
      />
    </>
  );
};

export default DrawerClosetRTC;
